module.exports = __webpack_public_path__ + "media/06 admire.115d9210.mp3";